'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import I18n from 'I18n';
import UnstyledButton from '../UnstyledButton';
import { hexToRGB } from '../../utils/color';

const getStyles = (selected, brandingColor) => {
  if (!selected) {
    return null;
  }

  const {
    r,
    g,
    b
  } = hexToRGB(brandingColor);
  return {
    borderColor: brandingColor,
    boxShadow: `0 3px 5px 0 rgba(${r}, ${g}, ${b}, 0.3)`
  };
};

const ViewPageDrawerItem = ({
  imageUrl,
  selected,
  index,
  onClick,
  brandingColor
}) => /*#__PURE__*/_jsxs(UnstyledButton, {
  className: "page-item m-all-2 flex-column align-center justify-between",
  onClick: onClick,
  tabIndex: selected ? 1 : 0,
  "aria-label": I18n.text('a11y.pageSelectorButton', {
    pageNumber: index + 1
  }),
  children: [/*#__PURE__*/_jsx("img", {
    src: imageUrl,
    className: "view-page-drawer-image m-bottom-2",
    style: getStyles(selected, brandingColor)
  }), /*#__PURE__*/_jsx("span", {
    className: "page-number",
    children: index + 1
  })]
});

ViewPageDrawerItem.propTypes = {
  brandingColor: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired
};
export default ViewPageDrawerItem;